module.exports = __webpack_public_path__ + "img/money.721307af.png";